import { ChangeDetectionStrategy,  Component, Inject, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-zahlartkassa-data-view',
  imports: [],
  templateUrl: './zahlartkassa.list-view.html',
  styleUrls: ['./zahlartkassa.list-view.css'],
})
export class ZahlartkassaListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();

  constructor() {}
}
